// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__26o05","notes":"Notes_notes__3i3WB","note":"Notes_note__3bzaI","markdown":"Notes_markdown__3NVvh"};